module.exports = __webpack_public_path__ + "static/media/FCP01@s.baab4af0.jpg";